function generateURL() {
  return {
    href: window.location.href,
    hostname: window.location.hostname,
    protocol: window.location.protocol,
  };
}

export { generateURL };
